import { createSlice } from "@reduxjs/toolkit";
import { getCourses, getModules, getCourseScore, joinSession, submitSessionFeedback } from './thunk';
import { submitAssignmentAnswer, submitAdditionalProblem } from "Slices/thunks";
export const initialState = {
  courses: [],
  modules: [],
  courseScore: {},
  loading: false,
  error: {}
};

const Course = createSlice({
  name: 'Course',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getCourses.fulfilled, (state, action) => {
      state.courses = action.payload;
    });

    builder.addCase(getCourses.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getModules.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getModules.fulfilled, (state, action) => {
      state.modules = action.payload;
      state.loading = false;
    });
  
    builder.addCase(getModules.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(submitAssignmentAnswer.fulfilled, (state, action) => {
      const updatedQuestion = action.payload[0] || {};
      console.log('updatedQuestion: ', updatedQuestion);

      state.modules = state.modules.map((item) => item.ID === updatedQuestion.ModuleID ? 
        {...item, 
          Sessions: item.Sessions.map((session) => session.ID === updatedQuestion.SessionID ? 
          {...session,
            SolvedQuestions: session.SolvedQuestions + 1,
          } : session
        )
        } : item)
    });
  
    builder.addCase(submitAssignmentAnswer.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(submitAdditionalProblem.fulfilled, (state, action) => {
      const updatedSession = action.payload[0] || {};

      state.modules = state.modules.map((item) => item.ID === updatedSession.ModuleID ? 
        {...item, 
          Sessions: item.Sessions.map((session) => session.ID === updatedSession.SessionID ? 
          {...session,
            SolvedProblems: session.SolvedProblems + 1,
          } : session
        )
        } : item)
    });
  
    builder.addCase(submitAdditionalProblem.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(joinSession.fulfilled, (state, action) => {
      const updatedSession = action.payload[0] || {};

      state.modules = state.modules.map((item) => item.ID === updatedSession.ModuleID ? 
        {...item, 
          Sessions: item.Sessions.map((session) => session.ID === updatedSession.ID ? 
          {...session,
            UserIDs: updatedSession.UserIDs
          } : session
        )
        } : item)
    });
  
    builder.addCase(joinSession.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(submitSessionFeedback.fulfilled, (state, action) => {
      const updatedSession = action.payload[0] || {};

      state.modules = state.modules.map((item) => item.ID === updatedSession.ModuleID ? 
        {...item, 
          Sessions: item.Sessions.map((session) => session.ID === updatedSession.ID ? 
          {...session,
            FeedbackID: updatedSession.ID
          } : session
        )
        } : item)
    });
  
    builder.addCase(submitSessionFeedback.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getCourseScore.fulfilled, (state, action) => {
      state.courseScore = action.payload;
    });

    builder.addCase(getCourseScore.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default Course.reducer;